export default class Images {
  constructor(element) {
    this.element = element;

    this.init();
  }

  init() {
    console.log("Images");

    this.offset = 0;
    this.limit = 16;

    this.loadMoreBtn = document.getElementById('images__buttons__more');
    this.loadAllBtn = document.getElementById('images__buttons__all');
    this.buttonContainer = document.getElementById('images__buttons');

    this.loadMoreBtn.addEventListener('click', this.loadMoreImages.bind(this));
    this.loadAllBtn.addEventListener('click', this.loadAllImages.bind(this));

    // Charger les premiers articles lors du chargement de la page
    this.loadMoreImages();
  }

  loadMoreImages() {
    console.log("more");
    fetch(`/dashboard/controllers/get_more_images.php?offset=${this.offset}&limit=${this.limit}`)
      .then(response => response.json())
      .then(data => {
        document.getElementById('images__cards').innerHTML += data.html;
        this.offset += this.limit;
        this.checkIfAllLoaded(this.offset);
      });
  }

  loadAllImages() {
    console.log("all");
    fetch(`/dashboard/controllers/get_more_images.php?load_all=true`)
      .then(response => response.json())
      .then(data => {
        document.getElementById('images__cards').innerHTML = data.html;
        this.buttonContainer.style.display = 'none';
      });
  }

  checkIfAllLoaded(totalImages) {
    console.log("checkIfAllLoaded");
    fetch(`/dashboard/controllers/get_all_images.php`)
      .then(response => response.json())
      .then(data => {
        console.log(data.total)
        console.log(totalImages)
        if (totalImages >= data.total) {
          this.buttonContainer.style.display = 'none';
        }
      });
  }
}
